// Supersets organized by phase and workout
export const SUPERSETS = {
  phase_1: {
    workout_1: [
      {
        id: 'BSuAdR4RShWkZOOxBZrPcQ',
        supersetId: '111',
        sequence: 0,
        description: 'Ladder drills & Toe drops',
        exercise1: {
          name: 'Ladder drills (Phase 1)',
          video: 'https://youtu.be/tHpzKnAXhOo',
          documentation: '3 sets: 1 set = 2 times down and back of 3 different drills of your choice\n\n- High knees\n\n- Forward jumps\n\n- Sideways jumps\n\n- Foward fast feet (inside in)\n\n- Ickey shuffle\n\n- In-out forward jumps (one side)',
          hasLevels: false,
          hasSide: false,
          hasReps: false,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: true,
        },
        exercise2: {
          name: 'Toe drops',
          video: 'https://youtu.be/Xnl9NsVA1mo',
          documentation: '3 x 6-8 reps',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'M.jqCmwGSVqIQaYbl5jVBg',
        supersetId: '112',
        sequence: 1,
        description: 'Goblet squat w/foot elevated & Single-leg balance',
        exercise1: {
          name: 'Goblet squat (uninjured foot elevated)',
          video: 'https://youtu.be/nu30G5bZ8Aw',
          documentation: '3 x 6-8 reps',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: true,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Single-leg balance',
          video: 'https://youtu.be/F-ZKf1unaU4',
          documentation: '3 x 20-30 seconds/side',
          hasLevels: false,
          hasSide: true,
          hasReps: false,
          hasHoldTime: true,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'QZsrgHu3Qtqsqvw0nyCQ9A',
        supersetId: '113',
        sequence: 2,
        description: 'Hamstring bridge march & Copenhagen plank',
        exercise1: {
          name: 'Hamstring bridge march',
          video: 'https://youtu.be/wIvaoVdpbtk',
          documentation: '3 x 16-20 alternating marches',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Copenhagen plank (4 levels)',
          video: 'https://youtu.be/iV6E9DMWE5Q',
          documentation: '3 x 20-30 seconds/side',
          hasLevels: true,
          hasSide: true,
          hasReps: false,
          hasHoldTime: true,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 4,
          isLadderDrill: false,
        },
      },
      {
        id: 'iWz0I8MVRBy06jffghXBIQ',
        supersetId: '114',
        sequence: 3,
        description: 'Lateral step down & Banded side steps',
        exercise1: {
          name: 'Lateral step-down',
          video: 'https://youtu.be/xpEWSla4iWU',
          documentation: '3 x 8-10/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: true,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Banded side steps (3 levels)',
          video: 'https://youtu.be/t7anZkBnLLM',
          documentation: '3 x 10-12 steps down, 10-12 steps back',
          hasLevels: true,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: true,
          levelNumber: 3,
          isLadderDrill: false,
        },
      },
    ],
    workout_2: [
      {
        id: 'cgN8yLmTQY2e0DCu5kQKIA',
        supersetId: '121',
        sequence: 0,
        description: 'Ladder drills & Pogo jumps',
        exercise1: {
          name: 'Ladder drills (Phase 1)',
          video: 'https://youtu.be/tHpzKnAXhOo',
          documentation: '3 sets: 1 set = 2 times down and back of 3 different drills of your choice\n\n- High knees\n\n- Forward jumps\n\n- Sideways jumps\n\n- Foward fast feet (inside in)\n\n- Ickey shuffle\n\n- In-out forward jumps (one side)',
          hasLevels: false,
          hasSide: false,
          hasReps: false,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: true,
        },
        exercise2: {
          name: 'Pogo jumps (2 levels)',
          video: 'https://youtu.be/aldpySaxRik',
          documentation: '3 x 10-12 reps',
          hasLevels: true,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
      },
      {
        id: '4Nvz14UsS0Ow0SJbq76tNg',
        supersetId: '122',
        sequence: 1,
        description: 'Single-leg squat & Side planking',
        exercise1: {
          name: 'Single-leg squats to box (2 levels)',
          video: 'https://youtu.be/SrEufr7eFYM',
          documentation: '3 x 8-10/side',
          hasLevels: true,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: true,
          hasBoxHeight: true,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Side planking (Phase 1) (2 levels)',
          video: 'https://youtu.be/kM1vRAik6VY',
          documentation: '3 x 20-30 seconds/side',
          hasLevels: true,
          hasSide: true,
          hasReps: false,
          hasHoldTime: true,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
      },
      {
        id: 'ypJB8qRAR0ucJKK8iwWRHw',
        supersetId: '123',
        sequence: 2,
        description: 'Single-leg glute bridge & Bear crawl iso holds',
        exercise1: {
          name: 'Single-leg glute bridge',
          video: 'https://youtu.be/izR2-KK3vaA',
          documentation: '3 x 10-12/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Bear crawl iso holds',
          video: 'https://youtu.be/bXbyIXavcEI',
          documentation: '3 x 20-30 seconds',
          hasLevels: false,
          hasSide: false,
          hasReps: false,
          hasHoldTime: true,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'T7Hgvp3FTtuElCJGwawkQQ',
        supersetId: '124',
        sequence: 3,
        description: 'Y balance reach & Weighted wall sit',
        exercise1: {
          name: 'Y balance reach',
          video: 'https://youtu.be/-SHv75OQHeo',
          documentation: '3 x 3-5/side (1 reach in each direction = 1 rep)',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Weighted wall sit',
          video: 'https://youtu.be/lnkJhqipwaM',
          documentation: '3 x 20-30 seconds',
          hasLevels: false,
          hasSide: false,
          hasReps: false,
          hasHoldTime: true,
          hasWeight: true,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
    ],
  },
  phase_2: {
    workout_1: [
      {
        id: 'XclIDoK9SkG1rPI.ufbwRw',
        supersetId: '211',
        sequence: 0,
        description: 'Ladder drills & Linear low hurdle jumps',
        exercise1: {
          name: 'Ladder drills (Phase 2)',
          video: 'https://youtu.be/B17taqJ169M',
          documentation: '3 sets: 1 set = 2 times down and back of 3 different drills of your choice\n\n- In-out forward jumps (both sides)\n\n- Forward hops (continuous, every rung)\n\n- Hop skotch\n\n- In-out sideways jumps (one side)\n\n- Sideways high knees\n\n- Sideways running man',
          hasLevels: false,
          hasSide: false,
          hasReps: false,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: true,
        },
        exercise2: {
          name: 'Linear low hurdle jumps',
          video: 'https://youtu.be/Jun87oULvYw',
          documentation: '3 x 10-12 reps',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: true,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'Iqb53t9MQMOf6wPNI5kJDg',
        supersetId: '212',
        sequence: 1,
        description: 'Lateral box jumps & Pike leg extenion',
        exercise1: {
          name: 'Lateral box jumps',
          video: 'https://youtu.be/lxXaN61KBnw',
          documentation: '3 x 4-6/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: true,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Pike leg extension (3 levels)',
          video: 'https://youtu.be/c3mumvnK03g',
          documentation: '3 x 8-10 or 6-8/side',
          hasLevels: true,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 3,
          isLadderDrill: false,
        },
      },
      {
        id: 'i-ty26W0QdCeFi550uu1uA',
        supersetId: '213',
        sequence: 2,
        description: 'Single-leg squat & Hip thrust march',
        exercise1: {
          name: 'Single-leg squat (self catch)',
          video: 'https://youtu.be/UR2p3sOAOp0',
          documentation: '3 x 6-8/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Hip thrust march',
          video: 'https://youtu.be/Ch80hbFOUa8',
          documentation: '3 x 16-20 alternating marches',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: '8.M93tXOTOuurteuG.5z4Q',
        supersetId: '214',
        sequence: 3,
        description: 'Copenhagen plank & 3-way toe taps',
        exercise1: {
          name: 'Copenhagen plank (4 levels)',
          video: 'https://youtu.be/XPxzvhiGSQw',
          documentation: '3 x 20-30 seconds/side',
          hasLevels: true,
          hasSide: true,
          hasReps: false,
          hasHoldTime: true,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 4,
          isLadderDrill: false,
        },
        exercise2: {
          name: '3-way toe taps (with band)',
          video: 'https://youtu.be/f3xyquQazKE',
          documentation: '3 x 3-5/direction/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: true,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
    ],
    workout_2: [
      {
        id: 'cf6WSQg8Qwq96F-mwC7-YQ',
        supersetId: '221',
        sequence: 0,
        description: 'Ladder drills & Lateral low hurdle jumps',
        exercise1: {
          name: 'Ladder drills (Phase 2)',
          video: 'https://youtu.be/B17taqJ169M',
          documentation: '3 sets: 1 set = 2 times down and back of 3 different drills of your choice\n\n- In-out forward jumps (both sides)\n\n- Forward hops (continuous, every rung)\n\n- Hop skotch\n\n- In-out sideways jumps (one side)\n\n- Sideways high knees\n\n- Sideways running man',
          hasLevels: false,
          hasSide: false,
          hasReps: false,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: true,
        },
        exercise2: {
          name: 'Lateral low hurdle jumps',
          video: 'https://youtu.be/DDU-VTrEeLM',
          documentation: '3 x 12-16 reps',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: true,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'feZThndFTduAQeZb9JHKBg',
        supersetId: '222',
        sequence: 1,
        description: 'Rotational box jumps (90°) & Bird dog',
        exercise1: {
          name: 'Rotational box jumps (90°)',
          video: 'https://youtu.be/d2phA5erK4Y',
          documentation: '3 x 4-6/side',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: true,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Bird dog',
          video: 'https://youtu.be/hjoQMjYJO8o',
          documentation: '3 x 8-10/side',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'CNm-1g0CTb6IjgUVYeUYaQ',
        supersetId: '223',
        sequence: 2,
        description: 'Single-leg squat & Hamstring bridge slides',
        exercise1: {
          name: 'Single-leg squat (vertical leg support)',
          video: 'https://youtu.be/rxMqWBBLWqE',
          documentation: '3 x 6-8/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: true,
          hasBoxHeight: true,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Hamstring bridge slides (3 levels)',
          video: 'https://youtu.be/OEsC8gstwZI',
          documentation: '3 x 8-10 or 6-8/side',
          hasLevels: true,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 3,
          isLadderDrill: false,
        },
      },
      {
        id: 'h7YHb1FyQr6RZElH2z7rjA',
        supersetId: '224',
        sequence: 3,
        description: 'Side planking & Single-leg calf raises',
        exercise1: {
          name: 'Side planking phase 2 (2 levels)',
          video: 'https://youtu.be/jEXw0lyha2A',
          documentation: '3 x 20-30 seconds/side',
          hasLevels: false,
          hasSide: true,
          hasReps: false,
          hasHoldTime: true,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Single-leg calf raises',
          video: 'https://youtu.be/9z81AzT-O0E',
          documentation: '3 x 10-12/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
    ],
  },
  phase_3: {
    workout_1: [
      {
        id: 'pc7AF0.FSSidHSYUvsLVfg',
        supersetId: '311',
        sequence: 0,
        description: 'Ladder drills & Lateral high knees',
        exercise1: {
          name: 'Ladder drills (Phase 3)',
          video: 'https://youtu.be/2xZ_TgWrgL8',
          documentation: '3 sets: 1 set = 2 times down and back of 3 different drills of your choice\n\n- In-out forward hops (one side)\n\n- In-out sideways hops (outside leg, one side)\n\n- In-out sideways hops (inside leg, one side)\n\n- In-out sideways jumps (both sides)\n\n- Sideways hops (outside leg)\n\n- Sideways hops (inside leg)\n\n- Forward jumps (90° turn)\n\n- Sideways 90° hip turn jumps\n\n- Forward hop and stick (every other rung)\n\n- Lateral bounds\n\n- Cross-over step and stick',
          hasLevels: false,
          hasSide: false,
          hasReps: false,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: true,
        },
        exercise2: {
          name: 'Lateral high knees w/controlled landing',
          video: 'https://youtu.be/pZH-o0L9msA',
          documentation: '3 x 4-6 steps down, 4-6 steps back',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: true,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'zH8RCV48QD6OnhvVj6GdaQ',
        supersetId: '312',
        sequence: 1,
        description: 'Lateral hip plyos & Side lunges',
        exercise1: {
          name: 'Lateral hip plyos (2 levels)',
          video: 'https://youtu.be/8T4499F9l9o',
          documentation: '3 x 12-16 alternating reps',
          hasLevels: true,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Side lunges (2 levels)',
          video: 'https://youtu.be/bb5-IRXSVwI',
          documentation: '3 x 8-10/side',
          hasLevels: true,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: true,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
      },
      {
        id: 'h7SyTaEIT92ZwzU7m7wfog',
        supersetId: '313',
        sequence: 2,
        description: 'RFESS & Single-leg plyos',
        exercise1: {
          name: 'Rear foot elevated split squat',
          video: 'https://youtu.be/JlmxFAa4hPs',
          documentation: '3 x 8-10/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: true,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Single-leg plyos (2 levels)',
          video: 'https://youtu.be/FVKYx0fPZYI',
          documentation: '3 x 6-8/side',
          hasLevels: true,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: true,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
      },
      {
        id: 'KOmQTIxcQre4nku7tBAJSg',
        supersetId: '314',
        sequence: 3,
        description: 'Single-leg RDL & Landing control',
        exercise1: {
          name: 'Single-leg RDL',
          video: 'https://youtu.be/ldyTY54MwOg',
          documentation: '3 x 8-10/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: true,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Landing control (2 levels)',
          video: 'https://youtu.be/cHodnby4UDw',
          documentation: '3 x 8-10 or 6-8/side',
          hasLevels: true,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: true,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
      },
    ],
    workout_2: [
      {
        id: 'DvrJp4V2RS25jiIaGRZeMQ',
        supersetId: '321',
        sequence: 0,
        description: 'Ladder drills & Superdog',
        exercise1: {
          name: 'Ladder drills (Phase 3)',
          video: 'https://youtu.be/2xZ_TgWrgL8',
          documentation: '3 sets: 1 set = 2 times down and back of 3 different drills of your choice\n\n- In-out forward hops (one side)\n\n- In-out sideways hops (outside leg, one side)\n\n- In-out sideways hops (inside leg, one side)\n\n- In-out sideways jumps (both sides)\n\n- Sideways hops (outside leg)\n\n- Sideways hops (inside leg)\n\n- Forward jumps (90° turn)\n\n- Sideways 90° hip turn jumps\n\n- Forward hop and stick (every other rung)\n\n- Lateral bounds\n\n- Cross-over step and stick',
          hasLevels: false,
          hasSide: false,
          hasReps: false,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: true,
        },
        exercise2: {
          name: 'Superdog',
          video: 'https://youtu.be/5YUCJMOYFaw',
          documentation: '3 x 10-12/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'JF7av5L7QO2-p.wfy9-WkA',
        supersetId: '322',
        sequence: 1,
        description: 'Multi-plane hops & Skater squat',
        exercise1: {
          name: 'Multi-plane hops (2 levels, 2 parts)',
          video: 'https://youtu.be/IBSqY-PcQZA',
          documentation: '3 x 6-8/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: true,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Skater squat',
          video: 'https://youtu.be/T8W5U9eYH9o',
          documentation: '3 x 6-8/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: true,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: '0kn00b4sRkSdovV81cQAqA',
        supersetId: '323',
        sequence: 2,
        description: 'Squat jumps & Plank walk-out',
        exercise1: {
          name: 'Squat jumps',
          video: 'https://youtu.be/soIQNQcPcrg',
          documentation: '3 x 6-8 reps',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Plank walk-out',
          video: 'https://youtu.be/syPv5Ct3tOI',
          documentation: '3 x 6-8 reps',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'OB1OD8scTiargFAbtc2-TA',
        supersetId: '324',
        sequence: 3,
        description: 'Nordic quads & 1-leg hamstring bridge slides',
        exercise1: {
          name: 'Nordic quads',
          video: 'https://youtu.be/dXqzHcCIPK0',
          documentation: '3 x 6-8 reps',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: '1-leg hamstring bridge slides (2 levels)',
          video: 'https://youtu.be/_PGKsplAEG8',
          documentation: '3 x 6-8/side',
          hasLevels: true,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
      },
    ],
  },
  phase_4: {
    workout_1: [
      {
        id: 'W8-xt-RyReCZDdgXYdQb1A',
        supersetId: '411',
        sequence: 0,
        description: 'Ladder drills & Dead bugs',
        exercise1: {
          name: 'Ladder drills (Phase 4)',
          video: 'https://youtu.be/s-RaVyb-wRI',
          documentation: '3 sets: 1 set = 2 times down and back of 3 different drills of your choice\n\n- In-out foward hops (both sides)\n\n- In-out sideways hops (outside leg, both sides)\n\n- In-out sideways hops (inside leg, both sides)\n\n- Sideways 180° hip turn jumps\n\n- Forward carioca\n\n- Forward hop and stick (every third rung)\n\n- Forward fast feet (outside in)\n\n- Ice skaters (for distance)',
          hasLevels: false,
          hasSide: false,
          hasReps: false,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: true,
        },
        exercise2: {
          name: 'Dead bugs (2 levels)',
          video: 'https://youtu.be/xrqdT4fgeh8',
          documentation: '3 x 12-16 alternating reps',
          hasLevels: true,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
      },
      {
        id: 'xMOvLb.KRVO538eACRc1pA',
        supersetId: '412',
        sequence: 1,
        description: 'Medial hops & Split squat jump switches',
        exercise1: {
          name: 'Medial hops (2 levels)',
          video: 'https://youtu.be/63-GRBXnDf0',
          documentation: '3 x 3-5/side',
          hasLevels: true,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Split squat jump switches',
          video: 'https://youtu.be/NLOR93USkBQ',
          documentation: '3 x 12-16 alternating jumps',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'EfiRLTkgRua1A93pPu8zWg',
        supersetId: '413',
        sequence: 2,
        description: 'Sumo squats & 2 leg vertical to 1 leg land',
        exercise1: {
          name: 'Sumo squats',
          video: 'https://youtu.be/EQZN_zx0hf4',
          documentation: '3 x 8-10 reps',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: true,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: '2 leg vertical to 1 leg land',
          video: 'https://youtu.be/Lflj6050dT4',
          documentation: '3 x 6-8/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'g10aQ6r8S4KZOdnwFqBtFg',
        supersetId: '414',
        sequence: 3,
        description: 'Clamshell raises & Superman raises',
        exercise1: {
          name: 'Clamshell raises (2 levels)',
          video: 'https://youtu.be/b7Q8TdvAON0',
          documentation: '3 x 8-10/side',
          hasLevels: true,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Superman raises (2 levels)',
          video: 'https://youtu.be/xAHE5fK2LZA',
          documentation: '3 x 10-12 reps',
          hasLevels: true,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
      },
    ],
    workout_2: [
      {
        id: 'PRnHFT3NRRe5ItIBKf8GrQ',
        supersetId: '421',
        sequence: 0,
        description: 'Ladder drills & Plank shoulder taps',
        exercise1: {
          name: 'Ladder drills (Phase 4)',
          video: 'https://youtu.be/s-RaVyb-wRI',
          documentation: '3 sets: 1 set = 2 times down and back of 3 different drills of your choice\n\n- In-out foward hops (both sides)\n\n- In-out sideways hops (outside leg, both sides)\n\n- In-out sideways hops (inside leg, both sides)\n\n- Sideways 180° hip turn jumps\n\n- Forward carioca\n\n- Forward hop and stick (every third rung)\n\n- Forward fast feet (outside in)\n\n- Ice skaters (for distance)',
          hasLevels: false,
          hasSide: false,
          hasReps: false,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: true,
        },
        exercise2: {
          name: 'Plank shoulder taps',
          video: 'https://youtu.be/ufUsvBl_Yns',
          documentation: '3 x 16-20 alternating taps',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: '3AH40HL.QPutbstmmLD2tw',
        supersetId: '422',
        sequence: 1,
        description: 'Drop landing plyos & Rear foot elevated split squat jumps',
        exercise1: {
          name: 'Drop landing plyos (2 levels)',
          video: 'https://youtu.be/l5cLA0Z0zY4',
          documentation: '3 x 6-8 or 4-6/side',
          hasLevels: true,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: true,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Rear foot elevated split squat jumps (2 levels)',
          video: 'https://youtu.be/oxsQoqDG-Yk',
          documentation: '3 x 6-8/side',
          hasLevels: true,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
      },
      {
        id: 'A8aeLyysSES-wPmMTBl5og',
        supersetId: '423',
        sequence: 2,
        description: 'Walking lunges & Reverse crunches',
        exercise1: {
          name: 'Walking lunges (2 levels)',
          video: 'https://youtu.be/t8MzqjEZd_8',
          documentation: '3 x 16-20 alternating steps',
          hasLevels: true,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: true,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: 2,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Reverse crunches',
          video: 'https://youtu.be/-rWVWCD1TvE',
          documentation: '3 x 8-10 reps',
          hasLevels: false,
          hasSide: false,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
      {
        id: 'Km2b1-8ZRpK1zxH0HxUM8Q',
        supersetId: '424',
        sequence: 3,
        description: 'Single-leg crab bridge & Toe walking',
        exercise1: {
          name: 'Single-leg crab bridge',
          video: 'https://youtu.be/7kr8-snvSII',
          documentation: '3 x 8-10/side',
          hasLevels: false,
          hasSide: true,
          hasReps: true,
          hasHoldTime: false,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
        exercise2: {
          name: 'Toe walking',
          video: 'https://youtu.be/OBW46fayOtE',
          documentation: '3 x 20-30 seconds',
          hasLevels: false,
          hasSide: false,
          hasReps: false,
          hasHoldTime: true,
          hasWeight: false,
          hasBoxHeight: false,
          hasHurdleHeight: false,
          hasBandColor: false,
          levelNumber: null,
          isLadderDrill: false,
        },
      },
    ],
  },
};